<app-back-button />

<h1 *ngIf="!customerSpaceId">{{ 'customer-spaces.create-customer.title' | translate }}</h1>
<h1 *ngIf="customerSpaceId">{{ 'customer-spaces.update-customer.title' | translate }}</h1>
<div *ngIf="customerSpaceId && !isCustomerSpaceActive">
    <a class="primary-link" (click)="tryDeleteCustomerSpace()" *appShowAuthorize="'CUSTOMER_SPACE_DELETE'">
        <mat-icon svgIcon="delete" class="delete-icon"></mat-icon>
        <span>{{ 'customer-spaces.delete-customer.title' | translate }}</span>
    </a>
</div>

<h2>{{ 'customer-spaces.create-customer-form.company' | translate }}</h2>

<div>
    <app-create-user-form [customerSpaceId]="customerSpaceId" [cf]="customerForm"
        [deactivatedBy]="deactivatedBy" [deactivationTime]="deactivationTime"
        [isPortalAdministrator]="isPortalAdministrator"
        (enterClicked)="saveCustomer($event)" />

    <div class="button-group">
        <app-button-cancel (click)="navigateBack()" [disabled]="savePending$ | async" />
        <app-button-save (click)="saveCustomer($event)" [disabled]="!customerForm.valid || (savePending$ | async)" />
    </div>
</div>

<app-customer-space-users-table [users]="customerSpaceUsers" [isCustomerSpaceActive]="isCustomerSpaceActive"
    [customerSpaceId]="customerSpaceId" [titleTranslateKey]="'customer-spaces.user-management.employees'"
    (addEmployeeClicked)="openAddEmployeeDialog()" (editEmployeeClicked)="openEditEmployeeDialog($event)"
    (deleteEmployeeClicked)="deleteEmployee($event)">

</app-customer-space-users-table>

<app-loading-spinner-overlay *ngIf="savePending$ | async"
    [loadingHintTranslationKey]="(!customerSpaceId ? 'loading-hint.creation' : null)!"></app-loading-spinner-overlay>